import { Button, Card, Form } from '../../../ui';
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { Spinner } from '../../../ui';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuthFlow, useErrors, useSession } from '../../../../state/app-state';
import { reportError } from '../../../../state/app-state';
import { signInWithTwitter } from '../../../../hooks/useAuth';
import { isAuthenticated } from '../../../../services/authentication';

const TwitterCallbackPage: FunctionComponent = () => {
  const history = useHistory();
  const { search } = useLocation();

  // Query Params
  const searchParams = new URLSearchParams(search);
  const oauthToken = searchParams.get('oauth_token');
  const oauthVerifier = searchParams.get('oauth_verifier');
  const denied = searchParams.get('denied');

  const session = useSession();
  const authFlow = useAuthFlow();
  const errors = useErrors();
  // Distinguishes "attempt finished" from "never started" (the legacy code
  // leaned on isFetching being undefined before the first attempt).
  const startedRef = useRef(false);

  const [loading, setLoading] = useState(true);
  const [isAuth] = useState(isAuthenticated());

  const closeWindow = useCallback(() => {
    if (window.opener && session && session.token) {
      window.opener.postMessage(JSON.stringify(session), window.location.origin);
    }

    if (window.opener && window.opener.popupCompleted) {
      window.opener.popupCompleted();
    } else {
      history.push('/');
    }
  }, [session, history]);

  useEffect(() => {
    if (denied) {
      closeWindow();
      return;
    }

    if (!oauthToken || !oauthVerifier) {
      reportError(new Error('Missing "oauth_token" or "oauth_verifier".'));
      setLoading(false);
      return;
    }

    if (!authFlow.isFetching) {
      startedRef.current = true;
      signInWithTwitter(oauthToken, oauthVerifier, isAuth);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!startedRef.current || authFlow.isFetching) {
      return;
    }

    if (session && !errors.length) {
      closeWindow();
      return;
    }

    setLoading(false);
  }, [isAuth, session, authFlow, errors, closeWindow]);

  return (
    <div>
      <Card>
        <Card.Body>
          <h1 className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900 text-center mb-6">
            {(() => {
              if (loading) {
                return (
                  <>
                    <Spinner animation="grow"></Spinner> Authenticating...
                  </>
                );
              }
              return 'Oops, something went wrong';
            })()}
          </h1>
          <Form noValidate>
            {(() => {
              if (!loading) {
                return (
                  <Button
                    className="mt-4 w-full flex"
                    onClick={() => {
                      if (window.opener) {
                        window.close();
                      } else {
                        history.push('/');
                      }
                    }}
                  >
                    Back
                  </Button>
                );
              }
            })()}
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TwitterCallbackPage;
